/** Drag-and-drop MIME types used between the library and the timeline. */
export const DND_MEDIA = 'application/x-cutroom-media';
export const DND_SEQUENCE = 'application/x-cutroom-sequence';
export const DND_TRANSITION = 'application/x-cutroom-transition';
/** A library folder being moved into another one (library-internal). */
export const DND_MEDIA_FOLDER = 'application/x-cutroom-media-folder';

/**
 * What is currently being dragged out of the library. `dataTransfer.getData` is unreadable during
 * `dragover` (browser security), so the timeline reads this to preview the drop.
 */
export const activeDrag: { mediaId?: string; sequenceId?: string; folderId?: string } = {};

export function clearActiveDrag(): void {
  delete activeDrag.mediaId;
  delete activeDrag.sequenceId;
  delete activeDrag.folderId;
}
